import { usePlanningBreachStore } from './usePlanningBreachStore';

export const usePlanningBreachPayload = () => {
  const { get } = usePlanningBreachStore();
  const can_be_contacted =
    get('receiveConfirmationEmail').toLowerCase() == 'yes' ? true : false;
  const can_back_office_contact =
    get('contactUserOption').toLowerCase() == 'yes' ? true : false;
  const has_additional_details =
    get('anyMoreInfo').toLowerCase() == 'yes' ? true : false;
  const knows_responsible_party =
    get('whoIsResponsible').toLowerCase() == 'yes' ? true : false;

  const selectedDate = get('selectedDate');
  // JS Date months are 0-based (0 = January, 11 = December)
  const selectedDateObject = new Date(
    Number(selectedDate.selectedYear),
    Number(selectedDate.selectedMonth) - 1,
    Number(selectedDate.selectedDay),
  );

  // Convert to ISO 8601 UTC
  const firstNoticedDate = selectedDateObject.toISOString();

  const worksCompletedDate = get('worksCompletedDate');
  // JS Date months are 0-based (0 = January, 11 = December)
  const worksCompletedDateObject = new Date(
    Number(worksCompletedDate.selectedYear),
    Number(worksCompletedDate.selectedMonth) - 1,
    Number(worksCompletedDate.selectedDay),
  );

  // Convert to ISO 8601 UTC
  const completionDate = worksCompletedDateObject.toISOString();

  const has_special_characteristic =
    get('specialCharactarists') === '' ? 'No' : get('specialCharactarists');

  const has_secondary_feature =
    get('doesOwnerLiveAtProperty') === ''
      ? 'No'
      : get('doesOwnerLiveAtProperty');

  const has_tertiary_feature =
    get('shortTermLetsAd') === '' ? 'No' : get('shortTermLetsAd');

  const payload = {
    ChannelObject: {
      channel: 'Online',
      platform: 'React',
      session_id: get('sessionId'),
    },
    ServiceLocationObject: {
      address_line_1: get('issueLocationData.address_line_1'),
      address_line_2: get('issueLocationData.address_line_2'),
      town_city: get('issueLocationData.town'),
      county: get('issueLocationData.county'),
      postcode: get('issueLocationData.postcode'),
      country: get('issueLocationData.country'),
      UPRN: get('issueLocationData.UPRN'),
      USRN: get('issueLocationData.USRN'),
      latitude: Number(get('issueLocationData.latitude')),
      longitude: Number(get('issueLocationData.longitude')),
      easting: get('issueLocationData.easting'),
      northing: get('issueLocationData.northing'),
      additional_details: '',
      is_commercial: get('issueLocationData.is_commercial'),
      is_within_borough: get('issueLocationData.is_within_borough'),
      asset: {
        asset_id: 'string',
        layer_id: 559,
      },
    },
    ReporterObject: {
      can_back_office_contact,
      can_be_contacted,
      contact_id: null,
      ...(can_be_contacted || can_back_office_contact
        ? {
            name: {
              first_name: get('firstName'),
              last_name: get('lastName'),
            },
            contact_details: {
              email_address: get('email'),
              ...(can_back_office_contact
                ? { phone_number: get('phoneNumber') }
                : {}),
            },
          }
        : {}),
    },
    ReportObject: {
      violation_type: get('issueType'),
      first_noticed_date: firstNoticedDate,
      violation_description: get('issueInfo'),
      specific_location: get('locationOfIssueInfo'),
      problem_impact: get('problemInfo'),
      has_special_characteristic,
      characteristic_description: get('detailsOfSpecialChars'),
      completion_date: completionDate,
      has_secondary_feature,
      secondary_feature_details: get('doesOwnerLiveAtPropertyDetails'),
      has_tertiary_feature,
      tertiary_feature_details: get('detailsOfShortTermLetsAd'),
      how_condition_breached: get('howConditionBreached'),
      knows_responsible_party,
      responsible_party_info: get('detailsOfResponsibility'),
      has_additional_details,
      additional_notes: get('detailsOfAnyMoreInfo'),
    },
    ...(get('uploadedImagesBlob').length > 0 && {
      FileCollectionObject: {
        external: true,
        files: get('uploadedImagesBlob').map((imageblob) => ({
          path: imageblob.blob_uri,
          name: imageblob.filename,
        })),
      },
    }),
  };

  return payload;
};
